<app-soft-deletable-auditable-translatable-lookups [paginationResponseResolver]="client"
  [defaultPaginationParameters]="defualtPaginationParameters" [supportedActions]="supportedActions" [tableConfig]="{
    fields: [
      { name: translate.currentLang === 'ar' ? 'state.arabicName' : 'state.englishName', displayName: 'LOCATION_MANAGEMENT.STATE' }
    ],
    template: tableRowTemplate
  }" />

<ng-template #tableRowTemplate let-element>
  <td>{{ translate.currentLang === 'ar' ? element.state.arabicName : element.state.englishName }}</td>
</ng-template>
